// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reorder-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.reorder-label {
  font-family: 'Poppins';
  font-weight: 500;                    
  font-style: normal;                 
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.41px;
}

.reorder-stock-row {
    display: flex;
    gap: 12px;
}

.reorder-stock-card {
    flex: 1 1;
    background: #111;
    color: #fff;
    border-radius: 8px;
    padding: 12px;
    text-align: center;
}

.reorder-stock-value1 {
    font-size: 1.1vw;
    font-weight: 600;
    text-decoration: underline;
    padding-bottom: 12px;
}

.reorder-stock-value2 {
    font-size: 1.1vw;
    font-weight: 600;
    padding-bottom: 12px;
}

.reorder-stock-type {
    font-size: 0.8vw;
    opacity: 0.7;
}

.reorder-disclaimer {
   font-family: 'Poppins';
font-weight: 500;
font-style: Medium;
font-size: 16px;
text-decoration: underline;

}

.reorder-disclaimer .dot {
    width: 10px;
    height: 10px;
    background: #000;
    border-radius: 2px;
    margin-top: 2px;
}

.text{
font-family: 'Poppins';
font-style: Medium;
font-size: 14px;
line-height: 22px;
letter-spacing: -0.41px;
text-align: justify;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/CreateModal/reorderSettingsModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;GACG,sBAAsB;AACzB,gBAAgB;AAChB,kBAAkB;AAClB,eAAe;AACf,0BAA0B;;AAE1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;AACA,sBAAsB;AACtB,kBAAkB;AAClB,eAAe;AACf,iBAAiB;AACjB,uBAAuB;AACvB,mBAAmB;AACnB","sourcesContent":[".reorder-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.reorder-label {\n  font-family: 'Poppins';\n  font-weight: 500;                    \n  font-style: normal;                 \n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.41px;\n}\n\n.reorder-stock-row {\n    display: flex;\n    gap: 12px;\n}\n\n.reorder-stock-card {\n    flex: 1;\n    background: #111;\n    color: #fff;\n    border-radius: 8px;\n    padding: 12px;\n    text-align: center;\n}\n\n.reorder-stock-value1 {\n    font-size: 1.1vw;\n    font-weight: 600;\n    text-decoration: underline;\n    padding-bottom: 12px;\n}\n\n.reorder-stock-value2 {\n    font-size: 1.1vw;\n    font-weight: 600;\n    padding-bottom: 12px;\n}\n\n.reorder-stock-type {\n    font-size: 0.8vw;\n    opacity: 0.7;\n}\n\n.reorder-disclaimer {\n   font-family: 'Poppins';\nfont-weight: 500;\nfont-style: Medium;\nfont-size: 16px;\ntext-decoration: underline;\n\n}\n\n.reorder-disclaimer .dot {\n    width: 10px;\n    height: 10px;\n    background: #000;\n    border-radius: 2px;\n    margin-top: 2px;\n}\n\n.text{\nfont-family: 'Poppins';\nfont-style: Medium;\nfont-size: 14px;\nline-height: 22px;\nletter-spacing: -0.41px;\ntext-align: justify;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
